
        Component.define('full-slide', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $owl = $('.full-slider');
const $owlItem = $('.slide-item');

$owl.children().each( function( index ) {
    $(this).attr( 'data-position', index ); // NB: .attr() instead of .data()
});

$owl.owlCarousel({
    center: true,
    items: 1,
    loop: true,
    dots: true,
    autoWidth: true,
    autoplay: true,
    autoplayHoverPause: true,
    autoplayTimeout: 2500,
    slideTransition: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)',
    autoplaySpeed: 1600,

    responsive: {
        769: {
            dots: false,
            items: 2
        }
    }
});

$('.slide-item').on('click', function() {
    $owl.trigger('to.owl.carousel', $(this).data( 'position' ) );
});

        });